import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { EMPTY, iif, of } from 'rxjs';
import { map, mergeMap, withLatestFrom, catchError } from 'rxjs/operators';

/* notification service */
import { NotificationService } from 'src/app/features/shared/services/notification-service/notification.service';

/* jsonata object class */
import { JSONAtaObject } from 'src/app/features/shared/helper-classes';

/* lodash lib */
import * as lodash from 'lodash';

/* DataStorage interface for ngrx */
import { DataStorage } from 'src/app/features/data-stores/data-storage.interface';

/* navigate action */
import { Navigate } from 'src/app/features/data-stores/router-data-store/state/router-data-store.actions';

/* Workflow Management API Service */
import { WorkflowManagementControllerService } from 'src/app/features/shared/sdk/services/workflow-management-controller.service';

/* auth-data-store actions */
import * as AuthDataStoreActions from 'src/app/features/data-stores/auth-data-store/state/auth-data-store.actions';

/* transportation-data-store actions */
import * as TransportationDataStoreActions from 'src/app/features/data-stores/transportation-data-store/state/transportation-data-store.actions';

/* accommodation-data-store actions */
import * as AccommodationDataStoreActions from 'src/app/features/data-stores/accommodation-data-store/state/accommodation-data-store.actions';

/* daily-program-item-data-store actions */
import * as DailyProgramItemDataStoreActions from 'src/app/features/data-stores/daily-program-item-data-store/state/daily-program-item-data-store.actions';

/* client-data-store actions */
import * as ClientDataStoreActions from 'src/app/features/data-stores/client-data-store/state/client-data-store.actions';

/* tour-data-store actions */
import * as TourDataStoreActions from 'src/app/features/data-stores/tour-data-store/state/tour-data-store.actions';

@Injectable()
export class AppDataStoreEffects {
  constructor(
    private actions$: Actions,
    private store: Store<DataStorage>,
    private notificationService: NotificationService,
    private workflowManagementApi: WorkflowManagementControllerService,
  ) { 
    // prettier-ignore
    // #region customCode: data-store-effects__constructor__start
    
    // #endregion customCode: data-store-effects__constructor__start

    // prettier-ignore
    // #region customCode: data-store-effects__constructor__end
    
    // #endregion customCode: data-store-effects__constructor__end
  }

  resetAllState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthDataStoreActions.Logout),
      /* dataset */
      mergeMap((action) => {
        const data = action['payload'] ?? {};
        const initialPayload = of(JSONAtaObject.chain(data));
        return initialPayload;
      }),

      /* trigger success actions */
      mergeMap((jsonataObj) => {
        /* get value of the passed jsonata object */
        const data = <any>jsonataObj.value;
        return [
          TransportationDataStoreActions.ResetState(),
          AccommodationDataStoreActions.ResetState(),
          DailyProgramItemDataStoreActions.ResetState(),
          ClientDataStoreActions.ResetState(),
          TourDataStoreActions.ResetState(),
        ];
      }),
    ),
  );
}
